__turbopack_context__.v({
  "btn": "qBcJpG_btn",
  "btnFooter": "qBcJpG_btnFooter",
  "cards": "qBcJpG_cards",
  "content": "qBcJpG_content",
  "headContact": "qBcJpG_headContact",
  "p": "qBcJpG_p",
  "page-body-wrap": "qBcJpG_page-body-wrap",
  "pagehero": "qBcJpG_pagehero",
  "paragraph": "qBcJpG_paragraph",
  "paragraph-content": "qBcJpG_paragraph-content",
  "phonecontent": "qBcJpG_phonecontent",
  "section": "qBcJpG_section",
  "store": "qBcJpG_store",
  "t": "qBcJpG_t",
  "title": "qBcJpG_title",
  "wrap-container": "qBcJpG_wrap-container",
  "wrap-content": "qBcJpG_wrap-content",
});
